import { history } from "./History";
export function shuffle(array) {
    let currentIndex = array.length,  randomIndex;
  
    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
  
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  
    return array;
}

export function shortName(text){
    const splitted = text.split(' ')
    if(splitted.length > 1){
        if(!splitted[1][0]){
            return `${splitted[0][0]}`
        }
        return `${splitted[0][0]}${splitted[1][0]}`
    }else{
        if(text.length === 1){
            return `${text[0]}`
        }else if(text.length === 2){
            return `${text[0]}${text[1]}`
        }
        else{
            return `${text[0]}${text[2]}`
        }
    }
}

export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

export function nextPlayerId(current, total_player){
    if(current === total_player-1){
        return 0
    }else{
        return current+1
    }
}

export function emojiRank(rank){
    const rank_ = rank +1
    if(rank_ === 1){
        return '🔥 1'
    }else if(rank_ === 2){
        return '😋 2'
    }else if(rank_ === 3){
        return '👏 3'
    }else{
        return '🤡 4'
    }
}

export function handleExpired() {
    alert('Your session is expired, please connect your Spotify account again!')
    history.push('/logout')
}

export function isNonDecimal(num){
    if(num % 1 === 0){
        return true
    }else{
        return false
    }
}

export function timerFormat(time){
    let seconds = time
    if (seconds < 10) {
        seconds = `0${seconds}`.toString();
    }
    
      // The output in MM:SS format
      return seconds.toString();
}

export function getCurrentRound(quizTabID, perRoundCount){ 
    const id = quizTabID+1
    const roundCheck = id/perRoundCount
    if(isNonDecimal(roundCheck)){
        return roundCheck
    }else{
        return 1 + Math.floor(roundCheck)
    }
}

export function floater(int){
    return parseFloat(int).toFixed(1)
}